import { render, staticRenderFns } from "./AdminConversationsBrowser.vue?vue&type=template&id=60f4b698"
import script from "./AdminConversationsBrowser.vue?vue&type=script&lang=js"
export * from "./AdminConversationsBrowser.vue?vue&type=script&lang=js"
import style0 from "./AdminConversationsBrowser.vue?vue&type=style&index=0&id=60f4b698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports